import React from 'react';
import AdminLayout from 'components/layout/AdminLayout';
import { Helmet } from 'react-helmet';
import Header from 'components/layout/Partials/Header';
import FormRenderer from 'lib/FormBuilder/components/FormRenderer';
import { createQServerFormFields } from 'components/settings/SaaS/QServerFormFields';
import { Box } from '@material-ui/core';
import Section from 'components/UI/Section';
import * as Icon from 'react-feather';
import { defaultStyles } from 'utils/Theme';
import { useDispatch, useSelector } from 'react-redux';
import { qsServerSelector } from 'redux/qsServer/selector';
import { setQsServer } from 'redux/actions/qsServerActions';
import * as yup from 'yup';

const validationSchema = {
    app: yup
        .string('Qlik Sense App ID')
        .required('App Id is required'),
    webIntegrationId: yup
        .string('Web Integration Id')
        .required('Web Integration Id is required'),
    tenantUri: yup
        .string('Tenant URI')
        .required('Tenant URI is required'),

};

const SaaSQsServer = () => {
    const qsServer = useSelector(qsServerSelector);
    const classes = defaultStyles();
    const dispatch = useDispatch();
    console.log(qsServer);
    const submit = (data, setSubmitting) => {
        dispatch(setQsServer(data));
        setSubmitting(false);
    };

    const formFields = createQServerFormFields();
    return (
        <AdminLayout>
            <Helmet>
                <title>Qlik Sense Server</title>
            </Helmet>
            <Header>
                <h2 className="c-navbar__title">Qlik Sense Server Settings</h2>
            </Header>
            <Box className="u-m-xsmall">
                <Section>
                    <div className="u-p-small">
                        <div className="o-line">
                            <span className="c-icon c-icon--large u-mb-small">
                                <Icon.Server className={classes.colorPrimary} />
                            </span>
                            <h5 className="u-mb-xsmall">Qlik Sense Server</h5>
                        </div>
                        <div>
                            <p>
                                Qlik Sense details are required to define the
                                Qlik engine connection used to open applications
                                and get objects and to define where the Qlik
                                Sense client side software and extensions should
                                be loaded from.
                            </p>
                        </div>
                        <div className="c-divider u-mt-small u-mb-medium" />

                        {formFields && qsServer && (
                            <FormRenderer
                                formFields={formFields}
                                validationSchema={validationSchema}
                                submit={submit}
                                submitText="Save"
                                initialValues={qsServer}
                            />
                        )}
                    </div>
                </Section>
            </Box>
        </AdminLayout>
    );
};

export default SaaSQsServer;
